module.exports = function() {
  return new Worker(__webpack_public_path__ + "cb4de5cf9747c000179a.worker.js");
};